import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {connect} from 'react-redux';
import MaterialUiModal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import {modalHide} from 'actions/modal';
import styles from './styles.module.sass';

const mapStateToProps = (state) => ({
  modal: state.modal
});

@connect(mapStateToProps)
export default class Modal extends PureComponent {
  onClose = (actionOnClose) => {
    this.props.dispatch(modalHide());
    if (actionOnClose) actionOnClose();
  };

  render() {
    const {modal: {stack = []} = {}} = this.props;
    return [
      stack.map((modal, index) => {
        const {component, fullScreen, showCloseIcon = false, onClose: actionOnClose} = modal;
        if (!component) return null;
        return (
          <MaterialUiModal
            key={`modal-${index}`}
            className={cx(styles.box)}
            open={true}
            onClose={() => this.onClose(actionOnClose)}
          >
            {fullScreen
              ?
              <div className={cx('ModalFullScreen', styles.content, styles.modalDialogFullScreen)}>
                {showCloseIcon && <IconButton className={styles.close} onClick={this.onClose}><ClearIcon/></IconButton>}
                {component}
              </div>
              :
              <div className={cx(styles.content)}>
                {component}
              </div>
            }
          </MaterialUiModal>
        )
      })
    ];
  }
}

Modal.propTypes = {
  stack: PropTypes.arrayOf({
    open: PropTypes.bool,
    component: PropTypes.any,
    fullScreen: PropTypes.bool,
    showCloseIcon: PropTypes.bool,
    onClose: PropTypes.func,
  })
};


// WEBPACK FOOTER //
// ./src/components/common/Modal/Modal.jsx